<template>
  <v-sheet class="transparent-background-color" v-if="data">
    <v-row no-gutters v-if="formater.title">
      <v-spacer />
      <v-card-title
        h6
        class="font-weight-bold pa-1"
        :class="formater.title.class"
      >
        {{
          formater.title
            ? formater.title.formater
              ? $printUtils.getValue(data, formater.title)
              : formater.title.display_text
            : ""
        }}
      </v-card-title>
      <v-spacer />
    </v-row>
    <v-row
      no-gutters
      v-if="
        (formater.barcode && $printUtils.getValue(data, formater.barcode)) ||
        (formater.barcode_r && $printUtils.getValue(data, formater.barcode_r))
      "
      :class="isSmallPage ? 'mt-n10' : 'mt-n11'"
    >
      <Barcode
        v-if="formater.barcode && $printUtils.getValue(data, formater.barcode)"
        :value="$printUtils.getValue(data, formater.barcode)"
        width="1px"
        height="25px"
        font-size="14px"
      />
      <v-spacer />
      <Barcode
        v-if="
          formater.barcode_r && $printUtils.getValue(data, formater.barcode_r)
        "
        :value="$printUtils.getValue(data, formater.barcode_r)"
        width="1px"
        height="25px"
        font-size="14px"
      />
    </v-row>

    <v-row
      no-gutters
      v-for="(headers, rowIdx) in formater.headers"
      :key="rowIdx"
    >
      <v-col
        v-for="(item, idx) in headers"
        :key="idx"
        :cols="item.cols"
        :class="item.class + getFontSize"
      >
        {{ item.display_text }}
        <span v-if="item.display_text && item.field">
          {{ $t("Global.colon") }}
        </span>
        {{ $printUtils.getValue(data, item) }}
      </v-col>
    </v-row>
  </v-sheet>
</template>
<style scoped>
.font-weight-bold {
  font-weight: 700 !important;
}
.pa-1 {
  padding-left: 4px !important;
  padding-right: 4px !important;
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}
.mt-n10 {
  margin-top: -40px !important;
}
.mt-n11 {
  margin-top: -44px !important;
}
.small-page .v-card__title {
  font-size: 1rem !important;
}
.font-sizeS{
  font-size: 0.9rem !important;
}
.font-sizeM{
  font-size: 1.1rem !important;
}
.font-sizeB{
  font-size: 1.3rem !important;
}
</style>
<script>
import i18n from "@/i18n";
import { mapState } from "vuex";
import Barcode from "vue-barcode";
export default {
  components: {
    Barcode,
  },

  props: {
    formater: Object,
    data: Object,
  },

  computed: {
    isSmallPage() {
      return this.pageOptions[this.printPageSize].smallPage;
    },
    getFontSize() {
      return this.fontSizeOptions[this.printFontSize].class;
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["printPageSize", "printFontSize"]),
    // ↑ supportBrowser==1为支持打印分页页码的浏览器（chrome、Edge等），0为未判定，其他值为不支持
  },

  data: () => ({
    pageOptions: i18n.t("$print.pageOptions"),
    fontSizeOptions: i18n.t("$print.fontSizeOptions")
  }),
};
</script>